import React from "react";
// import TeamsMain from "../components/Teams/TeamsMain";
import LinkedinAccounts from "./LinkedinAccounts";

type Props = {};

const Teams = (props: Props) => {
  return (
    <div className="h-full min-h-0">
      {/* Legacy team management screen kept intact for fallback/reference:
          <TeamsMain /> */}
      <LinkedinAccounts />
    </div>
  );
};

export default Teams;
